import type { ConceptDef } from '../types';

export const echoicPhrases: ConceptDef = {
  kind: 'supervisorScored',
  id: 'echoic-phrases',
  label: 'Echoic Phrases',
  category: 'Echoic',
  description: 'Speak a short phrase; learner repeats it. Supervisor scores.',
  config: {
    promptMode: 'AUDIO',
    prompts: [
      { prompt: 'I want it' },
      { prompt: 'big dog' },
      { prompt: 'open the door' },
      { prompt: 'pick it up' },
      { prompt: 'all done' },
      { prompt: 'my turn' },
    ],
  },
};
